import { render, staticRenderFns } from "./goodsdetail.vue?vue&type=template&id=1fb1e954&scoped=true&"
import script from "./goodsdetail.vue?vue&type=script&lang=js&"
export * from "./goodsdetail.vue?vue&type=script&lang=js&"
import style0 from "./goodsdetail.vue?vue&type=style&index=0&id=1fb1e954&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1e954",
  null
  
)

export default component.exports